import { PayrollCountryType } from '@nxsys/types/models/Common';
import { roles } from '@nxsys/store/constants';
import { lazy } from 'react';

const PSRListing = lazy(
  () => import('../../../modules/revenueFilings/listing/PSR'),
);

const SubmitPSR = lazy(
  () => import('../../../modules/submitPSR'),
);

export const revenueFilingsHistoryConfig = (
  payrollCountry: PayrollCountryType,
) => {
  if (payrollCountry !== 'IRELAND') return [];
  return [
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/revenue-filings/psr',
      element: <PSRListing />,
    },
    {
      permittedRole: [roles.admin, roles.employer],
      path: '/revenue-filings/submit-psr',
      element: <SubmitPSR />,
    },
  ];
};
